import React from 'react'
import ListComponentProto from './list-proto'


export default function renderListInView(id:string, props:any) {
    return (
        <ListComponentProto
            renderMode="view"
            id={id}
            {...props}
        />
    )
}
